// Data splitting JS
// --
jQuery(document).on('page.ready', function () {
    $ = jQuery;

    Splitting();
    var inHeight = window.innerHeight / 100;
    document.documentElement.style.setProperty("--vh", inHeight + "px");

    // add [data-scrolled] visiblity attributes
    var smc = new ScrollMagic.Controller();
    $('[data-scrolled]').each(function () {
        var el = this;
        var sms = new ScrollMagic.Scene({
                triggerElement: this,
                offset: 50
            })
            .on('enter start', function (e) {
                $(el).attr('data-scrolled', 'in');
            })
            .on('leave end', function (e) {
                $(el).attr('data-scrolled', 'out');
            })
            .addTo(smc);
    });

    var ScrollDown = (function () {
        var $scrollBtn = $('.scroll-down');

        if (!$scrollBtn) return;

        $scrollBtn.click(function () {
            $('html,body').animate({ scrollTop: $('.' + this.dataset.scrollto).position().top - ($('#nav-bar').height()) }, 500, 'swing');

        });
    }());

});

(function ($) {

    /*****************************************************************
      Touch fix for devices to mimick hover effects
    ******************************************************************/

    $('*').on('touchstart', function () {
        $(this).trigger('hover');
    }).on('touchend', function () {
        $(this).trigger('hover');
    });

    /*****************************************************************
      Mobile menu
    ******************************************************************/
    $('#menu-toggle').click(function () {
        if ($('html').hasClass('playlist-modal-open')) {
            $('html').removeClass('playlist-modal-open');
            $('.playlist-modal .player').html('');
            $('.gestures-modal .player').html('');
        } else {
            $('html').toggleClass('menu-open');
            setTimeout(function () {
                $('nav .newsletter').removeClass('is-open');
            }, 1500);
        }
    });

    // Newsletter Signup in menu
    // ---
    $('body').on('click', '.full-screen-nav a[href="#newsletter"]', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $nav = $('.full-screen-nav');
        var $signup = $('nav .newsletter');
        var $form = $('nav .newsletter .content');

        if ($signup.hasClass('is-open')) {
            $signup.removeClass('is-open');
            $('nav .newsletter input').first().focus();
        } else {
            $signup.addClass('is-open');

            $('nav .info.section').css('height', $form.outerHeight());

            if ($(window).width() < 950) {
                $nav.animate({
                    scrollTop: $nav[0].scrollHeight - $nav.height()
                }, {
                    duration: 1000
                });
            }
        }
    });

    /*****************************************************************
      Add scroll direction and scrolled classes
    ******************************************************************/
    var lastScrollTop = 0;
    var scrollBufferDown = 10;
    var scrollBufferUp = 10;
    var checkScrolling = function () {
        var currentScroll = window.pageYOffset || document.documentElement.scrollTop;
        if (currentScroll > lastScrollTop + scrollBufferDown) {
            $('html').addClass('scrolling-down');
            lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
        } else if (currentScroll < lastScrollTop - scrollBufferUp) {
            $('html').removeClass('scrolling-down');
            lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
        }

        if (currentScroll > 10) {
            $('html').addClass('scrolled');
        } else {
            $('html').removeClass('scrolled');
        }
    };
    $(window).scroll(checkScrolling);

    /*****************************************************************
      Full Height sections for mobile
    ******************************************************************/
    var forceFullHeight = function () {
        $('[data-full-height]').each(function () {
            $(this).css('height', $(window).height());
        });
    };
    $(window).resize(forceFullHeight);
    $(document).on('page.ready', forceFullHeight);

    // Anything above this line runs only one time on first page load
    // Anything below this line runs after every ajax page load
    $(document).on('page.ready', function () {

        // Your site's jQuery goes inside this .ready() function.

        /*******************************************************************
              In case the .load is taking too long, remove the loading overlay
            ********************************************************************/
        /*setTimeout( function () {
          if ( !$( '.loader' ).hasClass( 'removed' ) ) {
            $( '.loader' ).fadeOut().addClass( 'removed' );
          }
        }, 1800 );*/

        /*****************************************************************
          Hide #navbar-left on scroll down, show on scroll up
        ******************************************************************/
        /*$( function () {
          // will move this later b/c global variables suck, but basically attaching
          //  functions to scroll events can be very expensive to performance...
          //  Fix this by checking if the user has scrolled on an interval instead
          //  of executing functions for every pixel scrolled.
          var didScroll;
          var lastScrollTop = 0;
          var delta = 5;
          var navbarHeight = $( '#navbar-left' ).outerHeight();

          $( window ).scroll( function ( event ) {
            didScroll = true;
          } );

          setInterval( function () {
            if ( didScroll ) {
              hasScrolled();
              //awayFromTop();
              didScroll = false;
            }
          }, 250 );

          function hasScrolled() {
            var st = $( this ).scrollTop();

            // Make sure they scroll more than delta
            if ( Math.abs( lastScrollTop - st ) <= delta )
              return;

            // If they scrolled down and are past the navbar, add class.
            // This is necessary so you never see what is "behind" the navbar.
            if ( st > lastScrollTop && st > navbarHeight ) {
              // Scroll Down
              $( '#navbar-left' ).removeClass( 'navbar-left-down' ).addClass( 'navbar-left-up' );
            } else {
              // Scroll Up
              if ( st + $( window ).height() < $( document ).height() ) {
                $( '#navbar-left' ).removeClass( 'navbar-left-up' ).addClass( 'navbar-left-down' );
              }
            }

            lastScrollTop = st;
          }
        }() );*/

        /*****************************************************************
          END Hover Effect Stuff
        ******************************************************************/

        /*****************************************************************
          Owl Carousels
        ******************************************************************/
        $('.example-slider').each(function () {
            var exampleSlider = $(this);
            exampleSlider.owlCarousel({
                loop: false,
                margin: 10,
                rewind: true,
                mouseDrag: false,
                items: 1,
                dots: true,
                nav: true,
                navText: [
                    '<button title"Left Button" class="leftbtn"></button>',
                    '<button title"Right Button" class="rightbtn"></button>'
                ]
            });
        });

        /*******************************************************************
          Basic Tabbing Functionality
        ********************************************************************/
        $('.multi-nav button').first().addClass('active');
        $('.paragraph-slides div').first().addClass('active');
        $('.right-content div').first().addClass('active');

        $('.multi-nav button').click(function (e) {
            e.preventDefault();

            var tabs = $(".multi-nav").children(),
                paragraphs = $(".paragraph-slides").children(),
                images = $(".right-content").children(),
                clickedTab = $(this),
                i = clickedTab.index(),
                newParagraph = paragraphs[i],
                newImages = images[i];

            tabs.removeClass("active");
            paragraphs.removeClass("active");
            images.removeClass("active");
            clickedTab.addClass("active");
            $(newParagraph).addClass("active");
            $(newImages).addClass("active");
        });

        /*****************************************************************
          For when we do a img src="example.svg" SVG use instead of the
          <svg> html markup
        ******************************************************************/

        $('img.svgx').each(function () {
            var $img = $(this);
            var imgID = $img.attr('id');
            var imgClass = $img.attr('class');
            var imgURL = $img.attr('src');

            $.get(imgURL, function (data) {
                // Get the SVG tag, ignore the rest
                var $svg = $(data).find('svg');

                // Add replaced image's ID to the new SVG
                if (typeof imgID !== 'undefined') {
                    $svg = $svg.attr('id', imgID);
                }
                // Add replaced image's classes to the new SVG
                if (typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', imgClass + ' replaced-svg');
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');

                // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
                if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
                    $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
                }

                // Replace image with new SVG
                $img.replaceWith($svg);

            }, 'xml');

        });

        /*****************************************************************
          Animation Library / Area.

          Scroll Magic + GSAP
        ******************************************************************/

        // init scroll magic
        var smcontroller = new ScrollMagic.Controller();

        /*$( 'header' ).each( function () {
          var me = $( this );
          var navBg = new ScrollMagic.Scene( {
              triggerElement: this,
              offset: me.height(),
              triggerHook: 'onLeave'
            } )
            .setClassToggle( '#nav-bar', 'bgtoggle' )
            .addTo( smcontroller );
        } );*/

        $('.fade-from-bottom').each(function () {
            var me = $(this);
            var showFromLeft = new ScrollMagic.Scene({
                    triggerElement: this,
                    triggerHook: .8
                })
                .on('start', function (event) {
                    $(me).addClass('visible')
                })
                .addTo(smcontroller);
        });

        /*****************************************************************
          END Scroll Magic + GSAP
        ******************************************************************/

        /*****************************************************************
          Cookie Handling
        ******************************************************************/
        function getCookie(cname) {
            var name = cname + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }

        function setCookie(cname, cvalue, exdays) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            var expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }
        /*****************************************************************
          END Cookie Handling
        ******************************************************************/

    }); // end .ready()

}(jQuery));